export default __webpack_public_path__ + "static/media/ac-imagen-oscura-gestion-administrativa.0c1d8a84.png";